// extracted by mini-css-extract-plugin
module.exports = {"container":"Expand_container__GmKDj","scrollContainer":"Expand_scrollContainer__swhtr"};